import React from 'react'
import HSEQuality from '../components/HSEQuality/HSEQuality'

const Quality = () => {
  return (
    <div>
        <HSEQuality />
    </div>
  )
}

export default Quality